<template>
  <ContentWrap>
    <el-button type="primary" class="mb-12px" @click="open()" v-hasPermi="['activity:banner:create']">
      <Icon icon="ep:plus" /> 新增轮播
    </el-button>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="sort" label="排序" width="80" />
      <el-table-column prop="title" label="标题" min-width="140" />
      <el-table-column label="图片" width="120">
        <template #default="{ row }">
          <el-image v-if="row.picUrl" :src="row.picUrl" style="width: 80px; height: 40px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column label="跳转" min-width="160">
        <template #default="{ row }">
          {{ linkTypeLabel(row.linkType) }} {{ row.linkValue || '' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="row.status === 0 ? 'success' : 'info'">{{ row.status === 0 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="open(row)" v-hasPermi="['activity:banner:update']">编辑</el-button>
          <el-button link type="danger" @click="remove(row.id)" v-hasPermi="['activity:banner:delete']">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>

  <Dialog v-model="visible" :title="form.id ? '编辑轮播' : '新增轮播'" width="560px">
    <el-form :model="form" label-width="90px">
      <el-form-item label="标题" required><el-input v-model="form.title" maxlength="64" /></el-form-item>
      <el-form-item label="图片" required>
        <UploadImg v-model="form.picUrl" directory="activity/banner" height="120px" width="360px" />
      </el-form-item>
      <el-form-item label="跳转类型">
        <el-select v-model="form.linkType" class="!w-full">
          <el-option :value="0" label="无" />
          <el-option :value="1" label="活动详情ID" />
          <el-option :value="2" label="内部路径" />
          <el-option :value="3" label="外链" />
        </el-select>
      </el-form-item>
      <el-form-item label="跳转值"><el-input v-model="form.linkValue" /></el-form-item>
      <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" /></el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="form.status" :active-value="0" :inactive-value="1" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as Api from '@/api/activity/banner'
import { UploadImg } from '@/components/UploadFile'

defineOptions({ name: 'ActivityBanner' })

const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const visible = ref(false)
const form = reactive<any>({
  id: undefined,
  title: '',
  picUrl: '',
  linkType: 0,
  linkValue: '',
  sort: 0,
  status: 0
})

const linkTypeLabel = (t: number) =>
  ({ 0: '无', 1: '活动', 2: '路径', 3: '外链' } as Record<number, string>)[t] || '-'

const load = async () => {
  loading.value = true
  try {
    list.value = (await Api.getBannerList()) || []
  } finally {
    loading.value = false
  }
}

const open = (row?: any) => {
  Object.assign(form, row || { id: undefined, title: '', picUrl: '', linkType: 0, linkValue: '', sort: 0, status: 0 })
  visible.value = true
}

const save = async () => {
  if (!form.title || !form.picUrl) {
    message.warning('请填写标题和图片')
    return
  }
  form.id ? await Api.updateBanner(form) : await Api.createBanner(form)
  message.success('保存成功')
  visible.value = false
  load()
}

const remove = async (id: number) => {
  await message.confirm('确定删除该轮播？')
  await Api.deleteBanner(id)
  message.success('已删除')
  load()
}

onMounted(load)
</script>
